import Page from './page';
import Modal from './modal';
import Empty from './empty';
import UserDetails from './user-details';
const ContentGroup = {
  Page,
  Modal,
  Empty,
  UserDetails
};
export default ContentGroup;
//# sourceMappingURL=index.js.map